// Recherche de cartes (16/07, demande Claude-Alain : « un moteur de recherche sur la partie
// map car avec le nombre on s'y perd »). Logique PURE (aucun DOM) : testée hors navigateur,
// consommée par le sélecteur de niveaux (level-picker-ui).

/** Minuscules + accents retirés : « Épave » et « epave » se retrouvent. */
export function normalizeSearch(s: string): string {
  return s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
}

/**
 * Une carte correspond si CHAQUE mot de la requête apparaît quelque part dans ses champs
 * cherchables (titre, auteur, nom du biome...). Requête vide = tout correspond. Les mots
 * peuvent venir de champs différents : « manoir papa » trouve la carte manoir DE papa.
 */
export function levelMatches(query: string, fields: (string | undefined)[]): boolean {
  const words = normalizeSearch(query).split(/\s+/).filter(Boolean)
  if (words.length === 0) return true
  const hay = normalizeSearch(fields.filter(Boolean).join(' '))
  return words.every((w) => hay.includes(w))
}
